import React from 'react'
import type { ProductDefinition } from '../types'
import { Lights } from './Lights'
import { viewer } from './viewer'
import { screenshot } from './screenshot'
import { Decorations } from './decorations'

const Builder = React.lazy(() =>
  import('./builder').then((m) => ({ default: m.Builder }))
)

export const product: ProductDefinition = {
  type: 'table',
  Lights,
  viewer,
  screenshot,
  Decorations,
  Builder,
}
